import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'finJoin',
  standalone: false,
})
export class JoinPipe implements PipeTransform {
  transform(input: unknown[], joinWith = ''): string {
    return Array.isArray(input) ? input.join(joinWith) : '';
  }
}
